/* eslint-disable @typescript-eslint/no-explicit-any */
import { isEmptyObject } from "@/lib/utils";
import { useQuery } from "@tanstack/react-query";

export function useFreeCount(user?: any) {
  return useQuery({
    queryKey: ["chat-usage", user?.id],
    queryFn: async () => {
      const res = await fetch("/api/chat/usage");
      const data = await res.json();
      if (!isEmptyObject(user)) {
        return data.memberUsageCount;
      }
      return data.count;
    },
  });
}
